import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {
  pUrl
} from "@/api/baseURL.js";
import {
  eUrl
} from "@/api/baseURL.js";
import {
  getBizList,
  getCmsList,
  getCourseList,
  getOfflineCourseList,
  getBizListByPost,
  loginByPost
} from "../../api/service.js"
import {
  getCourseCatetorySubsetFromHome,
} from "@/apiCloud/publicCourse";
import {
  getUnderlineCourseListFromEnterprise,
} from "@/apiCloud/home";

import $ from 'jquery'
export default {
  components: {
    myHeader,
    myFooter
  },

  data() {
    return {
      BannerList: [],
      noDataShow: true,
      onlineCourse: '', //在学课程
      studyTimeRankingList: [],
      generalMyNewsList: [],
      headlineMyNewsList: [],
      generalIndustryNewsList: [],
      headlineIndustryNewsList: [],
      catetoryPatentList: [],
      catetoryIndex: 0,
      bannerList: [],
      // activeName: '全部课程',  //标签tabs默认第一个
      onlineCoursesList: [], //线上课程
      offlineCoursesList: [ //线下课程
      ],
      offlineCatetoryIndex: 0,
      offlineCourses: [],
      onlineTotal: 0,
      publicCourseList: [ //公共课程部分数据
        {
          title: "全部课程",
        },
      ],
      empHeadportrait: '', //头像
      empName: '', //姓名
      empOnlinetime: '', //在线累计时长
      empIssueCourse: '', //已开通课
      userSturyTotalHourse: '0时0分0秒', //学习时长
      MustCourseCount: 0,
      noStudyCourse: 0,
      overCourse: 0,
      pageSize: 8,
      pageNum: 1,
      aa: false,
      bb: false,
      isLogin: true,
      catetoryList: [],
      offlineTotal: 0,
      offlinePageSize: 4,
      activeIndex: 0,
      marqueeList: [],
      bannerOfflinePageSize: 12,
      num: 1,
      offlineInterval: null,
      isJx: false,
      allTypeLiWidth: 0,
      tag: false,
      stepActive: 1,
      boutiqueCoursesList: [],
      password: "",
      username: "",
      isBlur: false,
      isBlur2: false
    }
  },
  computed: {
    top() {
      return -this.activeIndex * 36 + 'px';
    }
  },
  created() {
    this.checkIsLogin();
    //       var pUrl="http://xjqy.e.eceping.net";
    // var pUrl = window.location.href;
    // var pUrl = 'http://snyg.e.eceping.net';

    //是否是江西代理商访问
    if (pUrl == "http://jx.eceping.net" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://jx.eceping.net" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://jx.eceping.net:8080" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://jx.eceping.net:30001") { //jx.eceping.net域名时,显示关于我们
      // console.log(1111,this.isJx)
      this.isJx = true;
      localStorage.setItem('isJx', "true")
    }
    //是否是鄱阳代理商访问
    if (pUrl == "http://py.eceping.net" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://py.eceping.net" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://py.eceping.net:8080" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://py.eceping.net:30001") { //py.eceping.net域名时,显示关于我们
      // console.log(1111,this.isJx)
      this.isJx = true;
      localStorage.setItem('isJx', "true")
    }
  },
  mounted() {
    //banner上的线下课程滚动
    // var publicCourse=document.getElementsByClassName("in-bannerBox")[0]
    // console.log(1111,publicCourse)
    // publicCourse.style.minHeight=window.innerHeight-90+"px"
    // this.offlineInterval=setInterval(_=> {
    //     if(this.activeIndex < this.marqueeList.length) {
    //         this.activeIndex += 1;
    //     } else {
    //       this.activeIndex =0;
    //     }
    //   }, 1000);

    //线上课程分类宽度
    // var liList=$("#typeBox li")
    setTimeout(() => {
      let liList = document.getElementsByClassName("onlineTypeLi")
      var widths = 0
      for (var i = 0; i < liList.length; i++) {
        if (i == liList.length - 1) {
          widths += parseInt(liList[i].offsetWidth)
        } else {
          widths += parseInt(liList[i].offsetWidth) + 20
        }
      }
      this.allTypeLiWidth = widths
      if (this.allTypeLiWidth <= document.getElementById("typeBox").offsetWidth) { //判断箭头是否显示
        this.tag = false
        // $("#typeBox").width(this.allTypeLiWidth)
      } else {
        this.tag = true
      }
      // console.log(111,this.tag)
    }, 500)


  },
  beforeDestory() {
    clearInterval(this.offlineInterval)
    this.offlineInterval = null
  },
  methods: {
    loginBtn() {
      if (!this.username) {
        this.$message({
          title: '警告',
          message: '请填写用户名',
          type: 'warning'
        })
      } else if (!this.password) {
        this.$message({
          title: '警告',
          message: '请填写密码',
          type: 'warning'
        })
      } else {
        let url = 'employee/enterpriseEmployeeLogin'
        let data = {
          empUname: this.username,
          empUpass: this.password
        }
        loginByPost(url, data).then(res => {
          if (res.success) {
            this.$message({
              message: '登录成功',
              type: 'success',
              duration: '1000'
            })
            // debugger
            let tokenId = JSON.stringify(res.data.tokenId).replace(/\"/g, "")
            sessionStorage.setItem("userObj", JSON.stringify(res.data))
            localStorage.setItem("userObj", JSON.stringify(res.data))
            localStorage.setItem("tokenId", tokenId);
            //     var pUrl="http://ykxy.enterprise.eceping.net";
            // var pUrl = window.location.href;
            // var pUrl = 'http://snyg.e.eceping.net';

            //是否是江西代理商访问
            if (pUrl == "http://jx.eceping.net" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://jx.eceping.net" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://jx.eceping.net:8080" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://jx.eceping.net:30001") { //jx.eceping.net域名时,显示关于我们
              this.$router.push({
                path: "/studyCentre"
              })
            }
            //是否是鄱阳代理商访问
            if (pUrl == "http://py.eceping.net" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://py.eceping.net" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://py.eceping.net:8080" || pUrl.substring(0, pUrl.indexOf("/", 7)) == "http://py.eceping.net:30001") { //py.eceping.net域名时,显示关于我们
              this.$router.push({
                path: "/studyCentre"
              })
            }
            this.$router.go(0);
          } else {
            this.$message({
              message: res.message,
              type: 'warning'
            });
          }
        })

      }


    },
    openLogin() {
      sessionStorage.setItem('$isUserLogin', false);
      this.resetSetItem('$isUserLogin', false);
    },
    goStudy() {
      this.$router.push({
        path: "/studyCentre"
      })
    },
    goUser() {
      this.$router.push({
        path: "/userCenter"
      })
    },
    goOut() {
      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = "employee/enterpriseEmployeeLogOut";
        getBizListByPost(url).then(res => {
          if (res.success) {
            localStorage.clear();
            sessionStorage.clear();
            // location.reload();
            this.$router.push({
              path: "/realHome"
            })
            this.$router.go(0)
            // let url = window.location.href;
            // let list = url.split("/");
            // if (list[list.length - 1] == "home") {

            //   this.$router.go(0)
            // } else {
            //   this.$router.push({
            //     path: "/home"
            //   })
            // }
          } else {
            this.$message.error(res.message);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消退出登录'
        });
      });
    },
    //判断是否登录
    checkIsLogin() {
      var tokenId = localStorage.getItem('tokenId')
      if (tokenId != undefined && tokenId != "") {
        getBizList("employee/userTokenFailure", {
          tokenId: tokenId
        }).then(res => {
          if (res.success) {
            if (!res.data) {
              localStorage.setItem('tokenId', "");
              this.getEnterpriseWebsite()
              this.isLogin = false
            } else { //登录后
              // this.getStudyTimeRankingList()
              this.getMyNews()
              this.getIndustryNews()
              this.getEmployeeDetail()
              this.getBannerList()
              this.getStudyTime()
              this.getCourseCatetoryPatent(0)
              /*bannerList
                              this.getCourseCatetoryPatent(1)*/
              this.getCourseCatetoryPatentSubset()
              //   this.offlineCourses=this.offlineCoursesList[0].list
              this.getOfflineCourseList()
              this.getBannerOfflineCourseList()
            }
          }
        })
      } else { //未登陆
        this.getEnterpriseWebsite();
        this.isLogin = false
      }


    },
    getEnterpriseWebsite() { //根据域名获取企业id
      // var eUrl = window.location.href;
      // var eUrl = 'http://snyg.e.eceping.net';
      //   var eUrl="http://csqyl.enterprise.eceping.net"
      // var eUrl="http://xjqy.e.eceping.net";
      var param = {
        entpWebsite: eUrl /*eUrl.substring(0,eUrl.indexOf(":",5))*/
      };
      let url = "enterprise/getEnterpriseWebsite";
      getBizList(url, param).then(res => {
        if (res.success) {
          localStorage.setItem("enterpriseId", res.data.entpId);
          localStorage.setItem("entpCreditNo", res.data.entpCreditNo);
          this.getMyNews();
          this.getIndustryNews();
          // this.getBusinessCoursesList();
          this.getBannerList();
          this.getEnterpriseLog();
          this.getCourseCatetoryPatent(0)
          /*  this.getCourseCatetoryPatent(1)*/
          this.getCourseCatetoryPatentSubset();
          // this.offlineCourses=this.offlineCoursesList[0].list
          this.getOfflineCourseList();
          // this.getStudyTimeRankingList();
          this.getBannerOfflineCourseList()
        }
      })
    },
    //获取浏览器图标
    getEnterpriseLog() {
      let url = "enterprise/enterpriseInformation"
      getBizList(url).then(res => {
        if (res.success) {
          sessionStorage.setItem("webIco", res.data.webIco)
          sessionStorage.setItem("webIeIco", res.data.webIeIco)
          if (res.data.webIco) {
            $("#enterpriseLogo").attr("src", res.data.webIco)
          }
          if (res.data.webIeIco) {
            $("#browserIcon").attr("href", res.data.webIeIco)
          }
          if (res.data.empName) {
            document.title = res.data.empName
          }
        }
      })
    },
    //获取个人信息
    getEmployeeDetail() {
      let url = "employee/getEmployeeInformation"
      getBizList(url).then(res => {
        // console.log("人员信息",res)
        if (res.code == 0) {
          let data = res.data
          this.empHeadportrait = data.empHeadportrait ? data.empHeadportrait : "../../../static/empHeadportrait.png"
          localStorage.setItem("empHeadportrait", this.empHeadportrait)
          this.empName = data.empName
          localStorage.setItem("empTel", data.empTel)
          localStorage.setItem("empName", this.empName)
          localStorage.setItem("empCategory", data.empCategory)
        }
      })
    },
    //获取学习时长
    getStudyTime() {
      let url = "/home/getMustAndStartingCourse";
      getCourseList(url).then(res => {
        // console.log("学习时长",res)
        if (res.success) {
          let data = res.data;
          this.userSturyTotalHourse = data.userSturyTotalHourse ? data.userSturyTotalHourse : 0;
          this.onlineCourse = data.onlineCourse ? data.onlineCourse : 0;
          this.MustCourseCount = data.MustCourseCount ? data.MustCourseCount : 0;
          this.noStudyCourse = data.noStudyCourse ? data.noStudyCourse : 0;
          this.overCourse = data.overCourse ? data.overCourse : 0
        }
      })
    },
    //获取banner图
    getBannerList() {
      let url = "banner/getGatewayHomeBannerList"
      getBizList(url).then(res => {
        //  console.log("banner列表",res)
        if (res.success) {
          // this.bannerList=res.data
          this.bannerList.push(res.data[0])
        }
      })
    },
    //获取学习时长排行榜
    getStudyTimeRankingList() {
      let url = "employee/getStudyTimeRankingList"
      getBizList(url).then(res => {
        //    console.log("获取学习时长排行榜",res)
        if (res.code == 0) {
          for (var i = 0; i < res.data.length; i++) {
            let item = res.data[i]
            item.empHeadPortrait = item.empHeadPortrait ? item.empHeadPortrait : "../../../static/empHeadportrait.png"
          }
          this.studyTimeRankingList = res.data;
        }
        // console.log("jkjifjieiiieeii",this.studyTimeRankingList)
      })
    },
    //获取站内新闻
    getMyNews() {
      getMyNews(url).then(res => {
        // console.log("站内新闻",res)
        if (res.code == 0) {
          this.generalMyNewsList = res.data.generalNewsList
          this.headlineMyNewsList = res.data.headlineNewsList
        }
      })
    },
    //获取行业资讯
    getIndustryNews() {
      let url = "news/getIndustryNews"
      getCmsList(url).then(res => {
        // console.log("行业资讯",res)
        if (res.code == 0) {
          this.generalIndustryNewsList = res.data.generalNewsList
          this.headlineIndustryNewsList = res.data.headlineNewsList
        }
      })
    },
    handleClick(tab, event) {},
    //进课程详情
    GotoCourseDetail(id, packagebagId) {
      let packagebagIdA = packagebagId ? packagebagId : ''
      this.$router.push({
        // path:"/courseDetail",
        name: 'courseDetail',
        params: {
          courseId: id,
          packagebagId: packagebagIdA,
          oldPage: 1,
        }
      });
      localStorage.setItem("packagebagId", packagebagId)
      localStorage.setItem("courseId", id)
    },
    GotoNewsDetail(id) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          newsId: id,
        }
      });
    },
    //banner 图上的课程分类
    getCourseCatetoryPatentSubset() {
      let url = "home/getCourseCatetoryPatentSubsetByTokenId"
      getCourseList(url).then(res => {
        if (res.success) {
          this.catetoryList = res.data
          // let cateId=res.data[0].cateId
        }
      })
    },
    gotoPublicCentre(parentId, childId, courseSource) {
      // console.log(11111)
      this.$router.push({
        path: "/publicCourse",
        query: {
          parentId,
          childId,
          courseSource
        }
      });
    },
    goPublicList() {
      this.$router.push({
        path: "/publicCourse",
      });
    },
    // 线上课程
    getCourseCatetoryPatent(type) {
      var param = {
        courseSource: type
      };
      getCourseCatetorySubsetFromHome(url, param).then(res => {
        // console.log(res)
        this.catetoryPatentList = res.data
        let cateId = res.data[0].cateId
        this.selectCatetorPatent(cateId, 0, 0);
        this.selectCatetorPatent(0, 0, 1)
      })
    },
    selectCatetorPatent(cateId, index, type) {
      this.catetoryIndex = index
      let url = "/home/getStudyCentreList"
      let data = {
        entpId: "",
        cateId: cateId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        courseSource: type
      };
      getCourseList(url, data).then(res => {
        if (res.success) {
          if (type == 0) {
            this.onlineCoursesList = res.data;
            this.onlineTotal = res.total
          } else if (type == 1) {
            this.boutiqueCoursesList = res.data;
          }

        }
      })
    },
    // 线下课程
    offlineSelectPatent(index) {
      // this.offlineCourses=this.offlineCoursesList[index].list
      this.offlineCatetoryIndex = index
    },
    GotoOfflineCourseDetail(courseId) {
      this.$router.push({
        path: "/offlineCourseDetail",
        query: {
          courseId
        }
      });
    },
    getOfflineCourseList() {
      let data = {
        pageNum: 1,
        pageSize: this.offlinePageSize,
        orderby: 0
      };
      getUnderlineCourseListFromEnterprise(data).then(res => {
        if (res.success) {
          this.offlineCoursesList = res.data
          this.offlineTotal = res.total
        }
      })
    },
    //banner图上的线下课程报名
    getBannerOfflineCourseList() {
      let data = {
        pageNum: 1,
        pageSize: this.bannerOfflinePageSize,
        orderby: 0
      }
      getUnderlineCourseListFromEnterprise(data).then(res => {
        if (res.success) {
          this.marqueeList = res.data

        }
      })
    },
    leftClick() {
      var typeBox = document.getElementById("typeBox")
      var left = typeBox.offsetLeft
      if (left >= 0) {
        left = 0
      } else {
        left += 100
      }
      typeBox.style.left = left + "px";
    },
    rightClick() {
      var typeBox = document.getElementById("typeBox")
      var left = typeBox.offsetLeft;
      // console.log(parseInt(typeBox.offsetWidth),this.allTypeLiWidth)
      if (parseInt(typeBox.offsetWidth) >= this.allTypeLiWidth) {} else {
        left -= 100
      }
      typeBox.style.left = left + "px";
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/homeJx.js